<script>
import {
  getSubscriptionTypeLabel,
  orgHasActiveGuestAskGrant,
  getEffectivePropertyLimit,
} from "@/utils/subscriptionAccess.js";

const { hasFeature, orgHasProFamilyAccess } = require("@/utils/entitlements.js");

export default {
  data() {
    return {
      gcvTimeout: null,
    };
  },
  methods: {},
  computed: {
    gcvAppLoading: {
      get() {
        return this.$store.getters.appLoading;
      },
      set(val) {
        this.$store.commit("setAppLoading", val);
      },
    },
    gcvBreakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    gcvIsMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return false;
        case "lg":
          return false;
        case "xl":
          return false;
      }
    },
    gcvAppSettings: {
      get() {
        return this.$store.getters.appSettings;
      },
      set(val) {
        this.$store.commit("setAppSettings", val);
      },
    },
    gcvOrg: {
      get() {
        return this.$store.getters.org;
      },
    },
    gcvOrgId: {
      get() {
        return this.$store.getters.orgID;
      },
    },
    gcvOrgIsPremium() {
      return (
        this.gcvOrg &&
        (this.gcvOrg.account?.premium === true ||
          this.gcvOrg.subType === "Premium")
      );
    },
    gcvOrgIsPro() {
      return orgHasProFamilyAccess(this.gcvOrg);
    },
    gcvOrgHasProBranding() {
      return hasFeature(this.gcvOrg, "whiteLabel");
    },
    gcvOrgSubscriptionLabel() {
      return getSubscriptionTypeLabel(this.gcvOrg?.account?.subscriptionType);
    },
    gcvOrgIsGuestAsk() {
      const org = this.gcvOrg;
      if (!org?.account) {
        return false;
      }
      if (orgHasActiveGuestAskGrant(org)) {
        return true;
      }
      if (org.account.subscriptionType !== "GuestAsk") {
        return false;
      }
      if (!org.account.expires && typeof org.account.expiresAsNumber !== "number") {
        return true;
      }
      return this.gcvOrgIsSubscribed;
    },
    gcvHasGuestQAAccess() {
      return hasFeature(this.gcvOrg, "guestAsk");
    },
    gcvOrgPropertyLimit() {
      return getEffectivePropertyLimit(this.gcvOrg);
    },
    gcvOrgIsSubscribed() {
      return (
        this.gcvOrg &&
        this.gcvOrg.account &&
        this.gcvOrg.account.expires &&
        new Date(this.gcvOrg.account.expires) > new Date()
      );
    },
    orgIsSubscribed() {
      return (
        this.gcvOrg &&
        this.gcvOrg.account &&
        this.gcvOrg.account.expires &&
        new Date(this.gcvOrg.account.expires) > new Date()
      );
    },
    gcvSearchString: {
      get: function () {
        return this.$store.state.searchString;
      },
      set: function (newValue) {
        let searchString = newValue == null ? null : newValue.toLowerCase();
        this.$store.commit("setSearchString", searchString);

        if (this.gcvTimeout) clearTimeout(this.gcvTimeout);
        this.gcvTimeout = setTimeout(() => {
          this.$store.commit("setDebouncedSearchString", searchString);
        }, 500);
      },
    },
    gcvDebouncedSearchString: function () {
      return this.$store.getters.debouncedSearchString;
    },
  },
};
</script>
